const heroSlider = () => {
  const sliderElements = document.querySelectorAll('.homepage-slider');

  if (sliderElements.length > 1) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('homepage-slider-wrapper');

    //Get the first element's parent.
    const parent = sliderElements[0].parentNode;

    // Insert the new wrapper *before* the first element.
    parent.insertBefore(wrapper, sliderElements[0]);

    // Add the elements into the wrapper
    sliderElements.forEach(element => {
      wrapper.appendChild(element);
    });

    // Init slick
    $('.homepage-slider-wrapper').slick({
      autoplay: true,
      autoplaySpeed: 6000,
      dots: true,
      arrows: false,
      infinite: true,
      fade: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      pauseOnHover: false,
      pauseOnFocus: false,
    });
  }
};

const heroReviewsScroll = () => {
  const reviewsElements = document.querySelectorAll('.hero-26__reviews');
  if (reviewsElements.length > 0) {
    const handleClick = () => {
      const targetElement = document.getElementById('reviewsio-carousel-widget');
      if (targetElement) {
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - 50;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      }
    };

    reviewsElements.forEach(reviewsElement => {
      reviewsElement.addEventListener('click', handleClick);
      reviewsElement.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      });
    });
  }
};

export { heroSlider, heroReviewsScroll };
